interface DebitorResult {
    oxid: string;
    number: string;
    company: string;
    city: string;
}

export function initAgentAutocomplete(): void {
    const input    = document.getElementById('agentDebitorSearch') as HTMLInputElement | null;
    const oxidInput = document.getElementById('agentDebitorOxid') as HTMLInputElement | null;
    const dropdown = document.getElementById('agentDebitorDropdown') as HTMLUListElement | null;
    const clearBtn = document.getElementById('agentSearchClear') as HTMLButtonElement | null;
    const backdrop = document.getElementById('agentSearchBackdrop') as HTMLDivElement | null;

    if (!input || !oxidInput || !dropdown || !clearBtn) return;

    function showBackdrop(): void {
        backdrop?.classList.add('active');
        document.body.classList.add('has-agent-search-overlay');
    }
    function hideBackdrop(): void {
        backdrop?.classList.remove('active');
        document.body.classList.remove('has-agent-search-overlay');
    }

    let debounceTimer: ReturnType<typeof setTimeout>;
    let activeIndex = -1;
    let results: DebitorResult[] = [];

    function closeDropdown(): void {
        dropdown.hidden = true;
        activeIndex = -1;
        hideBackdrop();
    }

    function openDropdown(): void {
        dropdown.hidden = false;
    }

    function renderResults(items: DebitorResult[]): void {
        results = items;
        dropdown.innerHTML = '';
        activeIndex = -1;

        if (items.length === 0) {
            closeDropdown();
            return;
        }

        items.forEach((item, idx) => {
            const li = document.createElement('li');
            li.className = 'agent-bar__dropdown-item';
            li.innerHTML = `
                <span class="agent-bar__dropdown-item__number">${item.number}</span>
                <span class="agent-bar__dropdown-item__company">${item.company}</span>
                ${item.city ? `<br><span class="agent-bar__dropdown-item__city">${item.city}</span>` : ''}
            `;
            li.addEventListener('mousedown', (e) => {
                e.preventDefault();
                selectItem(idx);
            });
            dropdown.appendChild(li);
        });

        openDropdown();
    }

    function selectItem(idx: number): void {
        const item = results[idx];
        if (!item) return;

        input.value = `${item.number} ${item.company}`;
        oxidInput.value = item.oxid;
        clearBtn.classList.add('visible');
        closeDropdown();
    }

    function highlightItem(idx: number): void {
        const items = dropdown.querySelectorAll<HTMLLIElement>('.agent-bar__dropdown-item');
        items.forEach((el, i) => el.classList.toggle('active', i === idx));
        activeIndex = idx;
    }

    async function fetchResults(q: string): Promise<void> {
        if (q.length < 2) {
            closeDropdown();
            return;
        }

        try {
            const res = await fetch(`?cl=agentdebitor&fnc=search&q=${encodeURIComponent(q)}`);
            const data: DebitorResult[] = await res.json();
            renderResults(data);
        } catch {
            closeDropdown();
        }
    }

    input.addEventListener('focus', () => {
        showBackdrop();
    });

    input.addEventListener('input', () => {
        const val = input.value.trim();
        clearBtn.classList.toggle('visible', val.length > 0);

        if (oxidInput.value) {
            oxidInput.value = '';
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => fetchResults(val), 220);
    });

    input.addEventListener('keydown', (e) => {
        const items = dropdown.querySelectorAll<HTMLLIElement>('.agent-bar__dropdown-item');
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            highlightItem(Math.min(activeIndex + 1, items.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            highlightItem(Math.max(activeIndex - 1, 0));
        } else if (e.key === 'Enter' && activeIndex >= 0) {
            e.preventDefault();
            selectItem(activeIndex);
        } else if (e.key === 'Escape') {
            closeDropdown();
        }
    });

    input.addEventListener('blur', () => {
        setTimeout(closeDropdown, 150);
    });

    clearBtn.addEventListener('click', () => {
        input.value = '';
        oxidInput.value = '';
        clearBtn.classList.remove('visible');
        closeDropdown();
        input.focus();
    });

    document.addEventListener('click', (e) => {
        if (!input.contains(e.target as Node) && !dropdown.contains(e.target as Node)) {
            closeDropdown();
        }
    });
}
